export class LabelValueDTO {
  label: string
  value: string
  hasPermissions?: boolean

  constructor(value?: string, label?: string, hasPermissions?: boolean) {
    this.label = label
    this.value = value
    this.hasPermissions = hasPermissions
  }
}
